module.exports = __webpack_public_path__ + "public/images/icon-search.02ede596d7bac958ff51511a124c1536.svg";